<template>
  <section class="w-full">

    <!-- =========================================================
      1) OBJETIVOS (lista de íconos)
    ========================================================== -->
    <section :class="clases_seccion_base">
      <ListaAgendadoresLegacy
        :usar-estilos-legacy="false"
        :mostrar-titulo="true"
        :items="items_objetivos_final"
        wrapper-tag="div"
        wrapper-class="w-full"
        header-col-class="w-full"
        list-tag="div"
        item-tag="div"
        text-tag="p"
        img-loading="lazy"
        img-decoding="async"
        list-class="grid grid-cols-1 [@media(min-width:801px)]:grid-cols-2 justify-items-center gap-y-[24px] mt-6"
        items-col-class="w-full max-w-[520px] flex"
        item-row-class="flex items-center gap-[18px]"
        icon-class="w-[74px] h-[74px] block"
        text-class="m-0 text-[16px] leading-[18px] font-bold text-[#1f1f1f]"
      >
        <template #titulo>
          <div class="flex items-start justify-center gap-[8px]">
            <!-- triángulo negro (equivalente a tu “vector_negro”) -->
            <span class="inline-flex">
              <svg width="32" height="38" viewBox="0 0 12 12" aria-hidden="true">
                <path d="M3 2 L10 6 L3 10 Z" fill="#1f1f1f" />
              </svg>
            </span>

            <h2
              class="text-center font-bold text-[#1f1f1f]
                     text-[32px] leading-[30px]
                     max-[800px]:text-[25px] max-[800px]:leading-[30px]"
            >
              <span>{{ titulo_objetivos_linea_1 }}</span><br />
              <span>{{ titulo_objetivos_linea_2 }}</span>
            </h2>
          </div>
        </template>
        
      </ListaAgendadoresLegacy>
    </section>

    <!-- =========================================================
      2) SECCIÓN GRIS (diferencia alineación vs geometría)
    ========================================================== -->
    <section :class="[clases_seccion_base, 'bg-[#F1F2F2]']">
      <!-- título -->
      <div class="flex items-start justify-center gap-[8px] mb-[30px] max-[800px]:mb-[20px]">
        <span class="inline-flex">
          <svg width="32" height="38" viewBox="0 0 12 12" aria-hidden="true">
            <path d="M3 2 L10 6 L3 10 Z" fill="#1f1f1f" />
          </svg>
        </span>

        <h2
          class="text-center font-bold text-[#1f1f1f]
                 text-[32px] leading-[32px]
                 max-[800px]:text-[25px] max-[800px]:leading-[30px]"
        >
          {{ titulo_diferencia }}
        </h2>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2">
        <!-- texto 1 -->
        <div class="flex items-center min-h-[321px] p-[80px] max-[800px]:p-[20px]">
          <p class="m-0 text-[#3a3a3a] text-[16px] leading-[20px]">
            {{ texto_diferencia_1 }}
          </p>
        </div>

        <!-- imagen 1 (derecha en desktop, abajo en mobile) -->
        <figure class="m-0 w-full overflow-hidden min-h-[321px] h-[321px] max-[800px]:h-[260px]">
          <img
            :src="imagen_diferencia_1_url"
            :alt="imagen_diferencia_1_alt"
            class="block w-full h-full object-cover bg-transparent
                   max-[800px]:object-contain max-[800px]:bg-[#F1F2F2]"
            loading="lazy"
            decoding="async"
          />
        </figure>

        <!-- imagen 2 (izquierda SOLO desktop) -->
        <figure class="m-0 hidden md:block w-full overflow-hidden min-h-[321px] h-[321px]">
          <img
            :src="imagen_diferencia_2_url"
            :alt="imagen_diferencia_2_alt"
            class="block w-full h-full object-cover"
            loading="lazy"
            decoding="async"
          />
        </figure>

        <!-- texto 2 -->
        <div class="flex items-center min-h-[321px] p-[80px] max-[800px]:p-[20px]">
          <p class="m-0 text-[#3a3a3a] text-[16px] leading-[20px]">
            {{ texto_diferencia_2 }}
          </p>
        </div>

        <!-- imagen 2 (abajo SOLO mobile) -->
        <figure class="m-0 block md:hidden w-full overflow-hidden min-h-[321px] h-[321px] max-[800px]:h-[260px]">
          <img
            :src="imagen_diferencia_2_url"
            :alt="imagen_diferencia_2_alt"
            class="block w-full h-full object-cover
                   max-[800px]:object-contain max-[800px]:bg-[#F1F2F2]"
            loading="lazy"
            decoding="async"
          />
        </figure>
      </div>
    </section>

    <!-- =========================================================
      3) SECCIÓN BLANCA (importancia)
    ========================================================== -->
    <section :class="clases_seccion_base">
      <!-- título -->
      <div class="flex items-start justify-center gap-[8px] mb-[30px] max-[800px]:mb-[20px]">
        <span class="inline-flex">
          <svg width="32" height="38" viewBox="0 0 12 12" aria-hidden="true">
            <path d="M3 2 L10 6 L3 10 Z" fill="#1f1f1f" />
          </svg>
        </span>

        <h2
          class="text-center font-bold text-[#1f1f1f]
                 text-[32px] leading-[32px]
                 max-[800px]:text-[25px] max-[800px]:leading-[30px]"
        >
          {{ titulo_importancia }}
        </h2>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2">
        <!-- imagen 3 -->
        <figure class="m-0 w-full overflow-hidden min-h-[321px] h-[321px] max-[800px]:h-[220px]">
          <img
            :src="imagen_importancia_1_url"
            :alt="imagen_importancia_1_alt"
            class="block w-full h-full object-cover bg-transparent
                   max-[800px]:object-contain"
            loading="lazy"
            decoding="async"
          />
        </figure>

        <!-- texto 1 -->
        <div class="flex items-center min-h-[321px] p-[80px] max-[800px]:p-[20px]">
          <p class="m-0 text-[#3a3a3a] text-[16px] leading-[20px]">
            {{ texto_importancia_1 }}
          </p>
        </div>

        <!-- imagen 4 (mobile) -->
        <figure class="m-0 block md:hidden w-full overflow-hidden min-h-[321px] h-[321px] max-[800px]:h-[220px]">
          <img
            :src="imagen_importancia_2_url"
            :alt="imagen_importancia_2_alt"
            class="block w-full h-full object-cover
                   max-[800px]:object-contain"
            loading="lazy"
            decoding="async"
          />
        </figure>

        <!-- texto 2 -->
        <div class="flex items-center min-h-[321px] p-[80px] max-[800px]:p-[20px]">
          <p class="m-0 text-[#3a3a3a] text-[16px] leading-[20px]">
            {{ texto_importancia_2 }}
          </p>
        </div>

        <!-- imagen 4 (desktop) -->
        <figure class="m-0 hidden md:block w-full overflow-hidden min-h-[321px] h-[321px]">
          <img
            :src="imagen_importancia_2_url"
            :alt="imagen_importancia_2_alt"
            class="block w-full h-full object-cover object-[47%_50%]"
            loading="lazy"
            decoding="async"
          />
        </figure>
      </div>
    </section>

  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { PasoServicioItem } from '@/components/Comunes/ListaAgendadoresLegacy.vue';
import ListaAgendadoresLegacy from '@/components/Comunes/ListaAgendadoresLegacy.vue';

/**
 * SeccionGeometriaAutomotriz.vue
 * - Migración desde vista legacy (Laravel/Bootstrap + CSS inline) a Vue3/Nuxt3 + Tailwind.
 * - Sin dependencias externas.
 * - Paddings y comportamiento responsive replican los breakpoints legacy:
 *   - base: 70px 190px
 *   - <=800px: 20px
 *   - 1200–1800: 70px 130px
 */

const props = defineProps({
  // ---------------------------
  // 1) OBJETIVOS
  // ---------------------------
  tituloObjetivosLinea1: {
    type: String,
    default: 'La geometría automotriz tiene como objetivo que la conducción',
  },
  tituloObjetivosLinea2: {
    type: String,
    default: 'de un automóvil sea cómoda, estable y segura, proporcionando:',
  },
  itemsObjetivos: {
    type: Array as () => PasoServicioItem[],
    default: () => ([
      { key: 'obj-1', texto: 'Estabilidad en la carretera', icon_src: '/img/geometria/ico1.png', icon_alt: 'Estabilidad en la carretera' },
      { key: 'obj-2', texto: 'Facilidad de conducción', icon_src: '/img/geometria/ico2.png', icon_alt: 'Facilidad de conducción' },
      { key: 'obj-3', texto: 'Evitar la fatiga mecánica', icon_src: '/img/geometria/ico3.png', icon_alt: 'Evitar la fatiga mecánica' },
      { key: 'obj-4', texto: 'Disminuir el consumo de\ncombustible', icon_src: '/img/geometria/ico4.png', icon_alt: 'Disminuir el consumo de combustible' },
      { key: 'obj-5', texto: 'Prolongar la vida de los neumáticos.', icon_src: '/img/geometria/ico5.png', icon_alt: 'Prolongar la vida de los neumáticos' },
    ]),
  },

  // ---------------------------
  // 2) DIFERENCIAS (gris)
  // ---------------------------
  tituloDiferencia: {
    type: String,
    default: 'Alineación y geometría Automotriz ¿En qué se diferencia?',
  },
  textoDiferencia1: {
    type: String,
    default:
      'La alineación y la geometría automotriz son dos términos que a menudo se utilizan indistintamente para describir el proceso de ajustar las ruedas de un automóvil. Sin embargo, existen algunas diferencias sutiles entre los dos términos.\n' +
      'La alineación automotriz se refiere a la posición de las ruedas en relación con la carrocería del automóvil. Es un proceso mediante el cual se ajusta la posición de las ruedas para que estén paralelas entre sí y perpendiculares al suelo. La alineación correcta ayuda a asegurar una conducción segura y uniforme, y también ayuda a prevenir el desgaste prematuro de los neumáticos.',
  },
  textoDiferencia2: {
    type: String,
    default:
      'Por otro lado, la geometría automotriz se refiere al conjunto completo de ajustes que se realizan en el sistema de suspensión y dirección del vehículo. Incluye la alineación de las ruedas, así como otros ajustes como la convergencia, la inclinación y la caída. La geometría automotriz también se utiliza para ajustar la dirección y la suspensión del vehículo para que maneje de manera segura y uniforme.\n' +
      'En resumen, la alineación es solo una parte del proceso de geometría automotriz, y se refiere específicamente a la posición de las ruedas en relación con la carrocería del automóvil. La geometría automotriz, por otro lado, es un conjunto completo de ajustes que se realizan en la suspensión y dirección del vehículo para asegurar un manejo seguro y uniforme.',
  },
  imagenDiferencia1Url: { type: String, default: '/img/geometria/img1.jpg' },
  imagenDiferencia1Alt: { type: String, default: 'Alineación automotriz (imagen 1)' },
  imagenDiferencia2Url: { type: String, default: '/img/geometria/img2.jpg' },
  imagenDiferencia2Alt: { type: String, default: 'Geometría automotriz (imagen 2)' },

  // ---------------------------
  // 3) IMPORTANCIA (blanco)
  // ---------------------------
  tituloImportancia: { type: String, default: '¿Por qué es importante realizar este servicio?' },
  textoImportancia1: { type: String, default: '' },
  textoImportancia2: { type: String, default: '' },
  imagenImportancia1Url: { type: String, default: '/img/geometria/img3.jpg' },
  imagenImportancia1Alt: { type: String, default: 'Importancia del servicio (imagen 3)' },
  imagenImportancia2Url: { type: String, default: '/img/geometria/img4.jpg' },
  imagenImportancia2Alt: { type: String, default: 'Importancia del servicio (imagen 4)' },
});

const titulo_objetivos_linea_1 = computed(() => props.tituloObjetivosLinea1);
const titulo_objetivos_linea_2 = computed(() => props.tituloObjetivosLinea2);

const titulo_diferencia = computed(() => props.tituloDiferencia);
const texto_diferencia_1 = computed(() => normalizar_parrafo(props.textoDiferencia1));
const texto_diferencia_2 = computed(() => normalizar_parrafo(props.textoDiferencia2));

const titulo_importancia = computed(() => props.tituloImportancia);

// Si el usuario no define textos de importancia, reutilizo los mismos del legacy que pegaste.
const texto_importancia_1 = computed(() => normalizar_parrafo(props.textoImportancia1 || props.textoDiferencia1));
const texto_importancia_2 = computed(() => normalizar_parrafo(props.textoImportancia2 || props.textoDiferencia2));

const imagen_diferencia_1_url = computed(() => props.imagenDiferencia1Url);
const imagen_diferencia_1_alt = computed(() => props.imagenDiferencia1Alt);
const imagen_diferencia_2_url = computed(() => props.imagenDiferencia2Url);
const imagen_diferencia_2_alt = computed(() => props.imagenDiferencia2Alt);

const imagen_importancia_1_url = computed(() => props.imagenImportancia1Url);
const imagen_importancia_1_alt = computed(() => props.imagenImportancia1Alt);
const imagen_importancia_2_url = computed(() => props.imagenImportancia2Url);
const imagen_importancia_2_alt = computed(() => props.imagenImportancia2Alt);

const items_objetivos_final = computed(() =>
  (Array.isArray(props.itemsObjetivos) ? props.itemsObjetivos : []).map((i) => ({
    ...i,
    texto: (i.texto ?? '').replace(/\n/g, ' '), // el texto con saltos se controla visualmente por ancho; evitamos \n literal
  }))
);

/**
 * Clases base de sección:
 * - padding legacy exacto
 * - mobile <=800: padding 20px
 * - mid 1200–1800: px 130px
 */
const clases_seccion_base = computed(() => [
  'w-full',
  'py-[70px]',
  'px-[190px]',
  'max-[800px]:p-[20px]',
  '[@media(min-width:1200px)_and_(max-width:1800px)]:px-[130px]',
]);

function normalizar_parrafo(texto: string): string {
  // Limpia espacios y conserva saltos lógicos convertidos a espacio.
  return String(texto ?? '')
    .replace(/\r/g, '')
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean)
    .join(' ');
}
</script>
